import React, { useEffect, useState } from 'react';
import '../styles/layouts/loading.scss';
import { LoadingProps } from '../interfaces/common';
import { Spin } from 'antd';
import { useGlobalStore } from '../stores/globalState';

const RippleIndicator = () => {
  return (
    <div className="sys-ripple">
      <div className="sys-ripple__circle"></div>
      <div className="sys-ripple__circle"></div>
    </div>
  );
};

const Loading: React.FC<LoadingProps> = props => {
  const { children } = props;
  const storeGlobal = useGlobalStore();
  const { isLoading } = storeGlobal;
  const [shouldShowLoading, setShouldShowLoading] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (isLoading) {
      setShouldShowLoading(true);
    } else {
      timer = setTimeout(() => {
        setShouldShowLoading(false);
      }, 500);
    }

    return () => clearTimeout(timer);
  }, [isLoading]);

  return (
    <>
      <Spin indicator={<RippleIndicator />} spinning={shouldShowLoading}>
        {children}
      </Spin>
    </>
  );
};

export default Loading;
